import * as t from 'io-ts';
import _ from 'lodash';

import {makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';
import {makeApiType, makeEnumRuntimeType} from './apiTypes';
import {HubspotFieldTypesEnum} from './crmHubspotFieldModel';
import {CrmSyncMappingCustomFieldTypesEnum} from './crmSyncModel';
import {CustomFieldsEnum} from './customFieldModel';

/*
 * Runtime type.
 */

const RCrmHubspotMapping = t.readonly(
  t.record(
    makeEnumRuntimeType(HubspotFieldTypesEnum),
    t.readonlyArray(
      t.union([
        makeEnumRuntimeType(CustomFieldsEnum),
        makeEnumRuntimeType(CrmSyncMappingCustomFieldTypesEnum),
      ]),
    ),
  ),
);

const RCrmHubspotMetadata = t.readonly(
  t.type({
    mapping: RCrmHubspotMapping,
    allAccountsCount: t.number,
  }),
);

/*
 * Type.
 */

export interface CrmHubspotMappingModel extends t.TypeOf<typeof RCrmHubspotMapping> {}
export interface CrmHubspotMetadataModel extends t.TypeOf<typeof RCrmHubspotMetadata> {}

/*
 * IO methods.
 */

export function parseCrmHubspotMetadata(src: any): CrmHubspotMetadataModel {
  return {
    allAccountsCount: src.crm_resource_count,
    mapping: parseCrmHubspotMapping(src.mapping_options),
  };
}

const isHubspotFieldType = makeEnumTypeGuard(HubspotFieldTypesEnum);
export function parseCrmHubspotMapping(src: any): CrmHubspotMappingModel {
  // We need to strip out anything that is not a valid type from the mapping model.
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return _(src)
    .pickBy((_value, key) => isHubspotFieldType(key))
    .value() as CrmHubspotMappingModel;
}

/*
 * API type.
 */

export const ApiCrmHubspotMetadata = makeApiType(
  'crmHubspotMetadata',
  RCrmHubspotMetadata,
  parseCrmHubspotMetadata,
);
